export const creditsComment = `
                              . ......==+=======~...  .   .                      
                            ........++++=++++++++,...... .                      
                             .....:++=======++???I:.. ....                      
                            .....:++=========++??I+......                      
                             ...=+=+=========++=+?I=... ...   . ..              
                              ..+++==========+++?II?...... . .. ..              
                            ...+~=+===========++??II: ...........              
                             ..I=~:::=========~:~?III===,........              
                              .=7?~::::::~~:::::~?777777I??......              
                            .....?$I=::,,,,,,:::=I7I77IIIIII... .              
                            .......+?=:::::::::~=?7777I77777=. .                
                              .......+?=~::~:::~+?III77$$$$$I . .              
                            ..... ....:=?ZOOOOO8ZI7II7$$$$Z$~...                
                            ........:+++7=8OO88888I7III77I$:... .              
                  .  .  .....,,,,:,::::::,:,,:,,:=++?IIII:.......              
               .     . ..,,,,,,,,,,,:,,,::,,,::::~:::,:.. ... ...              
              ..     ..,,,,,,,,,,,,,:,,,,,,,,,:::::~~~,..........              
                  ...,::,,,,,,,,,,:==,,,,,,,,,,,::::~==~:. ...  .              
              .......:,::,,,,,,,,~=I+:,,,,,,,:,,,::::~==~:..... .....          
              .......::+,,,,,,,~=II=?=:,,,,,,,:,,,:::~=++=+:.....              
              ......::?:,,,::~+++=,,?+=:,,,,,,?,:,:::~==++++=:...              
              ....,=~?+::,:+?III,,,,,?+==,,,,,:?,:,,:~==++=+=++~...    ..      
               ..===:+=++?III~,,,,,,,,???==,,,,,I::,~~=++++===++?,..   ..      
       .  ......+=~~~?IIII=,,,,,,,,,,,,:???++~,,I7+,~~7=++===+++II:......      
      ........~++=~~::~NDDD,,,,,,,,,,,,,,DNI?I7???77?==7++~~~==+??I?... .      
        .....~++=~~=:,NOZZ,,,,,,,,,,,,,,+DDDDN,~I77~=7I7I+=~====++II?....      
        ....~++=~~=:::,N+M,,,,,,,,,,,,,,,N.ODDDI,,::~~~I+?=~~===++?II....      
      .....:++==~=+::::ND7,,,,,,,,,,,,,,~D.DD:,=:,,::~~==++=~~~==+?I7?:..      
       . ..++====+:::,,~,,:,,,,,,,,,,,,,,NDDN,,,,,,:::====+=~====+?I$II..      
       ...=+=====~:=~:,,....,~~.....,,,,,,+,,,:,,:::::~===+=~~~~==+?I7II.      
         .+===~=:=~::,.....D8888$.....,,,,,,,,:,::,,::~~==+=~~~~==+??$7?.      
        ..+====:::::,..  . .......... ..,,,,,::++=::::~~==+==~====+?I$7?~      
       ..=====~::::.....   . .   . .......,,,:::++++~:~==+=+======++I$7?+.   . .
       ..+=====~~:,....:   . .  . ... .. ..,,,,,::::::~=++++=~=~===+I77?=. . . .
       .~+===+?~~~,....+=.......   .?.......,,,,::::~~~++?++=~~~==++I?7?=,.    
      ..~====+I~==:,,,..,I........+I=...   .,::::::~~~=+??++==~===+?I?I+=:...  
       ..I???I77==:~::,,,,I?.,.:II+.,........:::::~~~==+???+=====++I7I?+=~...  
        ..777$$$=++=~~~:~:::?77+,,,,,,,,,,,,,::~~===+++?II?++====++?7I+~~,. ..  
       ...:ZZ7I+.~++=======~~~~~~~::::~:::::~:===++++??IIII?=====++I77=~,...   .
      .........  ..~+?+++++++===++===~~=~==~~=++?IIII777II=I?===++?I7?...     ..
      ...... ........~+?II????++++?++++==+=++????III777II+..I+??II7$$. ..      
      .... .... . .. .  ..~=+??????IIII?I?IIIIIIII777II=:....I7I7$Z7:...      ..
                   . . .  . ...,$I+++==+?+??+?++++=,..   .....IZ7?.......      
                  .     ...,=7788$~=7+++++DD77+~......... .............        
              ..   .~I ... .+?OI::O~==I7O8D8OO?+=,  . ..... .. ... ....      
                   .,DD.....+I8,=?,.$DDDNN8$$O8O7.,~=...   .. ..........        
                . . .+MZ...+?7O,.DOOOO+OOOOO8OO8O...,=, .. ........ .. ..      
              ..  ..:,,,,::II?OOZ8OOOOOOOOOOOOO8O.:,::+...                      
              .....~:,,,,:?I?++ZOOOOOOOOOOOOOOOOO~,,,:~=.                      
               . ..==:,::~MI==~+O8DOOOOOOO8OO8O$~,,,,,:=+.                      
               .   :??==?=~N==~+8?DOOOOOOO+,,,,,,,,:::=??.                      
              .   ...==...?I=++I8I8OOOOO8,,,,,,,,::::~+I=.                      
                  .  .....I??+?I888OO888I,,,,,:::~==+?7,.                      
                    .  . .7===+?8888O8888~::::~=++II7=. .                      
                     .....88?=++O?=8O888DD=+?I++DN$.... ..                      
                     .....II+=?+$==788888DDNDNNNNDO.,~,. .                      
                     .....I???IIZNDO8888888DDDDDD8..=:,,...   ..                
                     . ...I???IIO8888O88888O$Z$7$$7:=:,....    .                
                     .. ..I++=??OO88OD8Z$$$I???I7$O,=:......                    
                     .  ..8Z$$ZZOO8887?III77$ZZZODD,......... . .              
                     .  . O88888OOOOO$$ZZZO8DDDDDDD=:,...,,,... .              
                     .. ..O888OOOOOOOOOO8888888DDDD+~=:,,:::. ..                
                     .. ..8888OOOOOOOOOO8888888DDDD?===~~==+.                  
                     .. ..8888OOOOOOOOOO8888888DDDD?++??++:..                  
                     .. . 8888OOOOOOOOOO8888888DDDDIIII.... .  .                
                       ...888OOOOOOOOOOO88888888DDD+...                        
                       .. 8888OOOOOOOOOO8888888DDDN..                          
                        .....O8OOOOOOOOO888888DD... ..                          
                       . ....:=?III7I:,:77I?++?7...                            
                     . ..... .~:~=+I+. .:=::~=??...                            
                             .:::~=?=.. .~::~=?+.                              
                             .=~:~+?=....~,::=?+.                              
                             .+=~==I=....=~~=+?+...                            
                             .++==+I~.  .====+?=.                              
                             .??+??7:.  .+++?II=  .                            
                             ....... .  .?I?II7,...                            
                            ... . .................

                        **   LoL Scrims Finder  **
                      Developed by: Daniel Michael
                            Discord: @.GitCat 
`;
